import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n";

const projectId = (project) => project.id || `pipeline-${(project.title || project.label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;

export const UnderConstructionContent = ({ onOpen, customProjects = [], deletedProjectIds = [] }) => {
  const { t } = useLanguage();
  const deleted = new Set(deletedProjectIds);
  const projects = customProjects.filter((project) => !deleted.has(projectId(project)));

  return (
    <div className="space-y-4">
      {projects.length === 0 && (
        <>
          <p className="text-sm text-ink-soft leading-relaxed">
            {t("pipelinesNote")}
          </p>
          <p className="font-hand text-xl text-accentBlue rotate-[-2deg] inline-block">
            {t("pipelinesHand")}
          </p>
        </>
      )}

      {projects.map((project, index) => (
        <article key={projectId(project)} className="group border border-dashed border-[var(--paper-edge)] p-3 hover:border-ink/40 transition">
          <div className="relative overflow-hidden">
            {project.image ? (
              <img src={project.image} alt={project.title} className="w-full h-40 object-cover transition duration-700 group-hover:scale-[1.02]" />
            ) : (
              <div className="w-full h-40 bg-[var(--bg-board-2)] grid place-items-center text-ink-faint font-mono text-[10px] uppercase tracking-[0.18em]">Pipeline</div>
            )}
            <span className="absolute top-2 left-2 font-mono text-[10px] tracking-[0.2em] uppercase bg-paper/90 text-ink px-2 py-1">
              {t("no")} {String(index + 1).padStart(3, "0")}
            </span>
          </div>
          <div className="pt-3">
            <h3 className="font-display font-medium text-ink leading-tight">{project.title}</h3>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-faint mt-1">
              {project.year} {project.location ? `- ${project.location}` : ""}
            </p>
            <p className="text-sm text-ink-soft mt-2 leading-relaxed">{project.description}</p>
          </div>
          <button
            onClick={() => onOpen({ ...project, kind: t("projectPipelines"), category: project.location || project.category, no: index + 1 })}
            className="mt-3 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-ink hover:text-accentRed transition"
          >
            {t("viewProject")} <ArrowUpRight size={13} />
          </button>
        </article>
      ))}
    </div>
  );
};
